import http from '@/http'

export default {
  getDonationPageBySlug: (organization_code, slug) =>
    http.get(`/api/organizations/${organization_code}/slugs/${slug}/page`),
  getDefaultPageByOrganization: () => http.get('/api/default-page')
}
